import { combineReducers, configureStore } from '@reduxjs/toolkit';
import reducers from './reducers';
import { dealerApiMiddleware, dealerApiReducer } from './apis/dealerApi';
import { hondaRestApiMiddleware, hondaRestApiReducer } from './apis/hondaRestApi';
import { inventoryApiMiddleware, inventoryApiReducer } from './apis/inventoryApi';
import { layoutServiceApiMiddleware, layoutServiceApiReducer } from './apis/layoutServiceApi';
export const rootReducer = combineReducers({
    ...reducers,
    hondaRestApi: hondaRestApiReducer,
    inventoryApi: inventoryApiReducer,
    dealerApi: dealerApiReducer,
    layoutServiceApi: layoutServiceApiReducer,
});
const rootStateMiddleware = (store => next => action => {
    var _a;
    const rootState = store.getState();
    const reduxAction = action;
    const enhancedAction = {
        ...reduxAction,
        meta: {
            ...((_a = reduxAction.meta) !== null && _a !== void 0 ? _a : {}),
            rootState,
        },
    };
    return next(enhancedAction);
    // eslint-disable-next-line @typescript-eslint/ban-types
});
export const middleWares = [
    hondaRestApiMiddleware,
    inventoryApiMiddleware,
    dealerApiMiddleware,
    layoutServiceApiMiddleware,
    rootStateMiddleware,
];
export const getStore = () => {
    const globalStore = configureStore === null || configureStore === void 0 ? void 0 : configureStore({
        reducer: rootReducer,
        middleware: getDefaultMiddleware => getDefaultMiddleware({
            serializableCheck: false,
        }).concat(middleWares),
    });
    return globalStore;
};
export const store = getStore();
